import { render, staticRenderFns } from "./CreditNoteEditor.vue?vue&type=template&id=3523c054&scoped=true"
import script from "./CreditNoteEditor.vue?vue&type=script&lang=js"
export * from "./CreditNoteEditor.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteEditor.vue?vue&type=style&index=0&id=3523c054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3523c054",
  null
  
)

export default component.exports